module.exports = __webpack_public_path__ + "img/echartimg2.b6a0fbc2.png";